module.exports = __webpack_public_path__ + "1_0_59/img/check_mark.93100f1b.svg";